import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "previewImg flex-col" }
const _hoisted_2 = {
  class: "flex-bwn fx-1",
  style: {"margin-top":"10px"}
}
const _hoisted_3 = { class: "scrollbar-flex-content" }
const _hoisted_4 = ["onClick"]

import { t } from '@/plugins/i18n'


import TableButton from '@/components/Table/TableButton.vue'
import { ElMessage } from 'element-plus'
import { defineComponent, defineProps, defineEmits, reactive, ref, computed, watch, defineExpose } from 'vue'
import { ArrowLeftBold, ArrowRightBold } from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  imgList: {
    type: Array,
    default: () => {
      return []
    }
  },
  initialIndex: {
    type: Number,
    default: () => 0
  }
},
  setup(__props, { expose }) {

const props = __props


const banner = ref(props.imgList[props.initialIndex])
const resetBanner = () => {
  banner.value = props.imgList[props.initialIndex]
}
const targetImg = computed(() => {
  const index = props.imgList.findIndex(i => i === banner.value)
  return index < 0 ? 0 : index
})
const chooseImg = (i: any) => {
  banner.value = i
}
const previewScrollBar = ref()
const switchImg = (i: any) => {
  const index = props.imgList.findIndex(i => i === banner.value)
  if (i && index > 0) {
    banner.value = props.imgList[index - 1]
  }
  if (!i && index < props.imgList.length - 1) {
    banner.value = props.imgList[index + 1]
  }
  console.log(previewScrollBar)
  previewScrollBar.value.setScrollLeft((index - 1) * 70)
}

expose({
  resetBanner
})


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_image, {
      style: {"width":"360px","height":"360px"},
      src: banner.value || __props.imgList[0],
      fit: "contain",
      "preview-src-list": banner.value ? [banner.value] : __props.imgList,
      "preview-teleported": true,
      class: "banner"
    }, null, 8, ["src", "preview-src-list"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "swicthBtn flex-cen-ter",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (switchImg(1)))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeftBold))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_scrollbar, {
        class: "fx-1 scrollbar previewScrollBar",
        ref: (_value, _refs) => {
          _refs['previewScrollBar'] = _value
          previewScrollBar.value = _value
        },
        always: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.imgList, (i, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "scrollbar-flex-content-item",
                key: index,
                onClick: ($event: any) => (chooseImg(i))
              }, [
                _createVNode(_component_el_image, {
                  src: i,
                  fit: "cover",
                  class: _normalizeClass(_unref(targetImg) === index ? 'targetImg' : '')
                }, null, 8, ["src", "class"])
              ], 8, _hoisted_4))
            }), 128))
          ])
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", {
        class: "swicthBtn flex-cen-ter",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (switchImg(0)))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowRightBold))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})